<template>
  <div class="verified-port-number__wrap">
    <p class="verified-port-number__title">{{ checkNumberTitle }}</p>
    <div class="verified-port-number__list">
      <zm-tag
        v-for="(portNumber, index) in portNumberList"
        :closable="portNumberShowClear"
        :key="index"
        class="verified-port-number__list--item"
        @close="removeNumber(index)">
        {{ portNumber | phoneFormat }}
      </zm-tag>
    </div>
  </div>
</template>

<script>
import { parsePortNumber } from '@/plans/ZOOM_PHONE/helper/utils';

export default {
  name: 'PortNumberCheckedList',
  props: {
    portNumberList: {
      type: Array,
      default: () => [],
    },
    portNumberShowClear: Boolean,
  },
  filters: {
    phoneFormat: parsePortNumber,
  },
  computed: {
    checkNumberTitle() {
      const count = this.portNumberList.length || 0;
      return this.$t('billing.pbx.port_number.validated_numbers_desc_v1', [count]);
    },
  },
  methods: {
    removeNumber(index) {
      this.$emit('removeNumber', index);
    },
  },
};
</script>

<style lang="scss">
@import "./style/checked-number-list.scss";
</style>
